import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton from 'react-loading-skeleton';

import s from './styles.module.scss';

const SmsDashboardProfileInfoSkeleton: React.FC = () => {
  return (
    <div className={s['chat-profile']}>
      <div className={s['chat-profile-general']}>
        <div className={s['chat-profile__info']}>
          <div className={s['chat-profile__fullname']}>
            <Skeleton width={150} height={16} />
          </div>
          <div className={s['chat-profile__fullname']}>
            <Skeleton width={150} height={16} />
          </div>
        </div>
        <Skeleton width={270} height={31} />
        {Array(3)
          .fill(null)
          .map((_, index) => (
            <div key={index} className={s['chat-profile__item']}>
              <div className={s['chat-profile__inline']}>
                <Skeleton circle height={32} width={32} />
                <Skeleton width={150} height={20} />
              </div>
            </div>
          ))}
      </div>
      <div className={s['chat-profile-contact']}>
        <div className={s['chat-profile__item']}>
          <div className={s['chat-profile__inline']}>
            <Skeleton circle height={30} width={32} />
            <Skeleton width={150} height={20} />
          </div>
        </div>
        <div className={s['chat-profile__item']}>
          <div className={s['chat-profile__inline']}>
            <Skeleton circle height={30} width={32} />
            <Skeleton width={150} height={20} />
          </div>
        </div>
        <div className={s['chat-profile__item']}>
          <div className={s['chat-profile__inline']}>
            <Skeleton circle height={30} width={32} />
            <Skeleton width={150} height={20} />
          </div>
        </div>
      </div>
      <div className={s['chat-profile-account']}>
        <div className={s['chat-profile__item']}>
          <div className={s['chat-profile__inline']}>
            <Skeleton circle height={32} width={32} />
            <Skeleton width={150} height={20} />
          </div>
          {Array(7)
            .fill(null)
            .map((_, index) => (
              <div key={index} className={s['chat-profile__definition']}>
                <div className={s['chat-profile__definition-block']}>
                  <div className={s['chat-profile__definition-label']}>
                    <Skeleton width={100} height={20} />
                  </div>
                </div>
                <div className={s['chat-profile__definition-block']}>
                  <div className={s['chat-profile__definition-label']}>
                    <Skeleton width={130} height={20} />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SmsDashboardProfileInfoSkeleton;
